"use strict";

Shopify.theme.jsFeaturedProductList = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsFeaturedProductList = $.extend(this, Shopify.theme.getSectionData($section));
      this.createSlider();
  },
  createSlider: function createSlider() {
    var productSlider = $('.featured-product-list__slider');
    productSlider.slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: true,
      speed: 300,
      prevArrow:"<button type='button' class='arrow-image slick-prev slick-arrow'></button>",
      nextArrow:"<button type='button' class='arrow-image slick-next slick-arrow'></button>",
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1
          }
        }
      ]
    });
  },
  unload: function unload($section) {
    // var $slider = $section.find('.flickity-enabled');
    // $slider.slick('destroy');
  }
};


Shopify.theme.jsBeekeepingFeaturedList = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsFeaturedProductList = $.extend(this, Shopify.theme.getSectionData($section));
      this.createSlider();
  },
  createSlider: function createSlider() {
    var productSlider = $('.featured-product-list__slider');
    productSlider.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      // centerMode: true,
      // centerPadding: '15%',
      dots: true,
      speed: 300,
      prevArrow:"<button type='button' class='arrow-image slick-prev slick-arrow'></button>",
      nextArrow:"<button type='button' class='arrow-image slick-next slick-arrow'></button>",
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1
          }
        }
      ]
    });
  },
  unload: function unload($section) {
    // var $slider = $section.find('.flickity-enabled');
    // $slider.slick('destroy');
  }
};